import { toast } from 'react-toastify';
import { ApiOnBoardMMLite } from '../../../helper/HelperAuth';

const GetStatusMMLite = async (senderId, clientId) => {
  try {
    const response = await fetch(`${ApiOnBoardMMLite}mmlite_status?senderid=${senderId}&clientid=${clientId}`);
    if (!response.ok) {
      toast.error(
        'Something went wrong while getting status onboard MM Lite Sender',
        toast.POSITION.TOP_RIGHT
      );
    }
    const responseBody = await response.json();
    return responseBody;
  } catch (error) {
    toast.error(
      'Something went wrong while getting status onboard MM Lite Sender',
      toast.POSITION.TOP_RIGHT
    );
    return {};
  }
};

export default GetStatusMMLite;
